<div class="card coletor-container">
    <p-tabView>
        <p-tabPanel *ngIf="direitoVisualizarColetores" header="Coletores">
            <p-toolbar styleClass="mb-4 coletor-toolbar">
                <ng-template pTemplate="left">
                    <button pButton pRipple [disabled]="!direitoInserirColetores" label="Novo"
                        icon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"></button>
                </ng-template>

            </p-toolbar>

            <div class="coletor-table-wrapper" #tableWrapper>
                <p-table #dtColetores [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
                    [paginator]="true" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
                    [showCurrentPageReport]="true" [globalFilterFields]="['id','descricao']"
                    [scrollable]="true" [scrollHeight]="scrollHeight">


                <ng-template pTemplate="caption">
                    <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                        <h5 class="p-m-0">Coletores</h5>
                        <span class="p-input-icon-left mt-2 md:mt-0">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dtColetores.filterGlobal($event.target.value, 'contains')"
                                placeholder="Pesquisar..." />
                        </span>
                    </div>

                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 18%">Código</th>
                        <th style="width: 54%">Descrição</th>
                        <th class="col-acoes" style="width: 28%; min-width: 120px">Ações</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dt>
                    <tr>
                        <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                        <td><span class="p-column-title negrito">Descrição: </span>{{dt.descricao}}</td>
                        <td class="col-acoes" style="text-align: center; white-space: nowrap">
                            <span class="p-column-title negrito">Ações: </span>
                            <button pButton pRipple [disabled]="!direitoEditarColetores"
                                icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                                pTooltip="Editar" (click)="edit(dt)"></button>
                            <button pButton pRipple [disabled]="!direitoExcluirColetores"
                                icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                pTooltip="Excluir coletor" (click)="confirmarExclusao(dt)"></button>
                        </td>
                    </tr>
                </ng-template>

                </p-table>
            </div>
        </p-tabPanel>
        <p-tabPanel *ngIf="direitoVisualizarTipos" header="Tipos">
            <p-toolbar styleClass="mb-4 coletor-toolbar">
                <ng-template pTemplate="left">
                    <button pButton pRipple [disabled]="!direitoInserirTipos" label="Novo"
                        icon="pi pi-plus" class="p-button-success mr-2" (click)="openNewTipo()"></button>
                </ng-template>
            </p-toolbar>

            <div class="coletor-table-wrapper" #tableWrapperTipo>
                <p-table #dtTipos [value]="dataTipo" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
                    [paginator]="true" [rowHover]="true" dataKey="id"
                    currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
                    [showCurrentPageReport]="true" [globalFilterFields]="['id','descricao', 'ativo']"
                    [scrollable]="true" [scrollHeight]="scrollHeightTipo">


                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="p-m-0">Tipos</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dtTipos.filterGlobal($event.target.value, 'contains')"
                                placeholder="Pesquisar..." />
                        </span>
                    </div>

                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>Código
                        </th>
                        <th>Descrição
                        </th>
                        <th>Editar</th>

                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dt>
                    <tr>
                        <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>

                        <td><span class="p-column-title negrito">Descrição: </span>{{dt.descricao}}</td>


                        <td style="text-align: center;">
                            <span class="p-column-title negrito">Editar: </span>
                            <button pButton pRipple [disabled]="!direitoEditarTipos"
                                icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                                (click)="editTipo(dt)"></button>
                        </td>



                    </tr>
                </ng-template>

                </p-table>
            </div>
        </p-tabPanel>
    </p-tabView>

</div>
<p-dialog header="Coletor" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="descricao" pInputText formControlName="descricao">
                    <label for="descricao">Descrição</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">

                <label for="tipo_coleta_id">Tipo da coleta</label>
                <p-dropdown inputId="tipo_coleta_id" appendTo="body" [filter]="true" optionLabel="descricao"
                    [options]="dataTipo" formControlName="tipo_coleta_id">
                </p-dropdown>


            </div>

            <div class="field col-12 md:col-12 xl:col-12" [hidden]="!isTipoColetaComHost()">
                <p-floatlabel>
                    <input type="text" id="url_configuracao" pInputText formControlName="url_configuracao">
                    <label for="url_configuracao">URL de configuração</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12" [hidden]="!isTipoColetaComHost()">
                <p-floatlabel>
                    <input type="text" id="pasta_ftp" pInputText formControlName="pasta_ftp">
                    <label for="pasta_ftp">Pasta FTP</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-6">
                <p-floatlabel>
                    <input type="text" id="usuario_endpoint" pInputText formControlName="usuario_endpoint">
                    <label for="usuario_endpoint">Usuário</label>
                </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-6">
                <p-floatlabel>
                    <input type="password" id="senha_endpoint" pInputText formControlName="senha_endpoint">
                    <label for="senha_endpoint">Senha</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <label for="status">Status</label>
                    <p-dropdown inputId="status" appendTo="body" [filter]="true" [options]="dropDownStatus"
                        formControlName="status">
                    </p-dropdown>
                </p-floatlabel>
            </div>


        </form>

    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

<!-- Modal de confirmação de exclusão quando há estações vinculadas -->
<p-dialog header="Excluir coletor?" [(visible)]="modalExcluirComEstacoes" [modal]="true"
    [style]="{width: '500px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="false" (onHide)="fecharModalExcluirComEstacoes()">
    <div class="p-fluid" *ngIf="coletorParaExcluir && estacoesRelacionadas?.length">
        <p class="mb-3">
            Este coletor está vinculado à(s) seguinte(s) estação(ões):
        </p>
        <ul class="mb-3 p-pl-3">
            <li *ngFor="let est of estacoesRelacionadas"><strong>{{ est.nome }}</strong></li>
        </ul>
        <p class="mb-3">
            Ao excluir, os vínculos serão removidos (soft delete). Para evitar exclusões acidentais,
            digite <strong>Excluir coletor</strong> para confirmar.
        </p>
        <div class="field">
            <label for="input-excluir-coletor">Confirmação</label>
            <input id="input-excluir-coletor" type="text" pInputText
                [(ngModel)]="inputExcluirColetor"
                placeholder="Excluir coletor"
                [class.ng-invalid]="inputExcluirColetor && inputExcluirColetor !== textoConfirmacaoExclusao" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="fecharModalExcluirComEstacoes()"></button>
        <button pButton pRipple type="button" label="Excluir" icon="pi pi-trash"
            class="p-button-danger"
            [disabled]="inputExcluirColetor !== textoConfirmacaoExclusao"
            (click)="executarExclusaoComEstacoes()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Tipo" [(visible)]="displayModalTipo" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="formTipo" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="descricao" pInputText formControlName="descricao">
                    <label for="descricao">Descrição</label>
                </p-floatlabel>
            </div>


        </form>

    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModalTipo = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="saveTipo()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>
